import { useCallback, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useMediaQuery } from 'react-responsive'
import { changeEmailRequest } from '../../../api-client/identity'
import { Mobile } from '../../../components/media'
import Modal from '../../../components/modal'
import UpdateEmailRequestSuccess from '../views/update-email-request-success'
import AccountInformation from '../views/account-information'
import UpdateEmailRequest from '../views/update-email-request'

const VIEWS = { AccountInformation: 0, UpdateEmailRequest: 1, UpdateEmailSuccess: 2 }

export default function UpdateDetails({ onDetailsChange, onClose }) {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' })
  const [view, setView] = useState(VIEWS.AccountInformation)

  const {
    mutate: mutateEmail,
    isLoading: emailMutationInProgress,
    error: emailMutationError,
  } = useMutation({
    mutationFn: changeEmailRequest,
    onSuccess: () => setView(VIEWS.UpdateEmailSuccess),
  })

  const handleEmailUpdateRequest = useCallback((form) => mutateEmail(form), [mutateEmail])

  const handleAccountInformationChangeSuccess = useCallback(
    (data, variables) => {
      onDetailsChange((prev) => ({
        ...prev,
        ...variables,
      }))
    },
    [onDetailsChange],
  )

  return (
    <Modal onClose={onClose} hideCloseBtn={isMobile}>
      <Mobile>
        <button className='flatBtn backToAccount' onClick={onClose}>
          &#60; Back to Account
        </button>
      </Mobile>

      {view === VIEWS.AccountInformation && (
        <AccountInformation
          onEmailEdit={() => setView(VIEWS.UpdateEmailRequest)}
          onClose={onClose}
          onSuccess={handleAccountInformationChangeSuccess}
        />
      )}
      {view === VIEWS.UpdateEmailRequest && (
        <UpdateEmailRequest
          onSubmit={handleEmailUpdateRequest}
          emailMutationInProgress={emailMutationInProgress}
          serverErrors={emailMutationError}
          onClose={onClose}
        />
      )}
      {view === VIEWS.UpdateEmailSuccess && <UpdateEmailRequestSuccess onClose={onClose} />}

      <style jsx>{`
        .backToAccount {
          margin: 1rem 0 0 1.3rem;
          color: #a5a8b9;
          line-height: 1.6rem;
          font-size: 1.2rem;
          font-weight: bold;
        }
      `}</style>
    </Modal>
  )
}
